import ScanPlay from './src/scan-play-combined';
export default ScanPlay;